import React, { useEffect, useState } from 'react'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import ReactPlayer from 'react-player'
import useReveal, { revealClass } from '../hooks/useReveal'
import RevealImage from './revealImage'

export default function GalleryVideo({id, ph, title, images ,imgAlt, videos}) {
    const [ref, visible] = useReveal()

    return (

        <div ref={ref} id={id} className={`flex flex-col ${revealClass(visible)}`}>
          <h3>{title} </h3>
          <ResponsiveMasonry 
                columnsCountBreakPoints={{350: 1, 750: 1, 1024:2, 1280: 3}}
            >
            

                <Masonry gutter="20px">
                       {videos.map((videoUrl, index) => (
                        <div key={index} className=' relative w-full h-full bg-black '>
                          <ReactPlayer  className='aspect-video w-full h-full' width='100%' height='100%'
                           controls url={videoUrl}/>
                        </div>
                       ))}

                {images.map((image, index) => (
                  <RevealImage
                    key={index}
                    index={index}
                    src={image}
                    alt={"Maria_Estevez_"+title+"_"+index}
                  />
                ))}
                </Masonry>
            </ResponsiveMasonry>
        </div>

      );
    };